/** Lignes de chargement. Décoratives : le conteneur porte `aria-busy`. */
export function Skeleton({ lines = 1, width }: { lines?: number; width?: string }) {
  return (
    <>
      {Array.from({ length: lines }, (_, i) => (
        <span
          key={i}
          className="skeleton"
          style={{ width: width ?? (i === lines - 1 && lines > 1 ? '60%' : undefined) }}
        />
      ))}
    </>
  );
}

/** Squelette d'une liste « pastille + deux lignes + valeur à droite » (départs, timeline). */
export function SkeletonRows({ rows = 4, badge = 'square' }: { rows?: number; badge?: 'square' | 'round' }) {
  return (
    <ul className="skeleton-rows">
      {Array.from({ length: rows }, (_, i) => (
        <li key={i}>
          <span className={`skeleton skeleton--${badge}`} />
          <span className="skeleton-rows__text">
            <span className="skeleton" style={{ width: '70%' }} />
            <span className="skeleton" style={{ width: '40%' }} />
          </span>
          <span className="skeleton skeleton--value" />
        </li>
      ))}
    </ul>
  );
}
